import React, { useEffect, useState } from "react";

import { getImageUrl } from "src/Common/common";

const CalendarTicket = ({ status, startDateString, ticketNumber }) => {
  const [WOStatus, setWOStatus] = useState(status);
  useEffect(() => {
    const today = new Date();
    const startDate = new Date(startDateString);
    if (status === 100) setWOStatus("closed");
    if (startDate < today && status !== 100) {
      setWOStatus("open");
    } else if (startDate > today) {
      setWOStatus("scheduled");
    }
  }, [status, startDateString]);

  const getStyle = (status) => {
    if (status === "closed")
      return "flex items-center justify-between py-[2px] pl-1 pr-2 space-x-[2px] rounded-full text-[12px] border border-[#16A81C]";
    if (status === "open")
      return "flex items-center justify-between py-[2px] pl-1 pr-2 space-x-[2px] rounded-full text-[12px] bg-[#FFEC40]";
    if (status === "scheduled")
      return "flex items-center justify-between py-[2px] pl-1 pr-2 space-x-[2px] rounded-full text-[12px] text-white bg-[#408CFD]";
  };

  const getMarker = (type) => {
    if (type === "closed") return "/images/calendar/closed_marker.png";
    if (type === "open") return "/images/calendar/open_marker.png";
    if (type === "scheduled") return "/images/calendar/scheduled_marker.png";
  };

  return (
    <div className={getStyle(WOStatus)}>
      <img
        className="w-4 h-4 object-contain"
        src={getImageUrl(getMarker(WOStatus))}
        alt="ticket status"
      />
      <span>#{ticketNumber}</span>
    </div>
  );
};

export default CalendarTicket;
